import { render, staticRenderFns } from "./reviewPage.vue?vue&type=template&id=41221d1c&scoped=true"
import script from "./reviewPage.vue?vue&type=script&lang=js"
export * from "./reviewPage.vue?vue&type=script&lang=js"
import style0 from "./reviewPage.vue?vue&type=style&index=0&id=41221d1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41221d1c",
  null
  
)

export default component.exports